import "./style.scss";

const ButtonUi = ({ id = "", label = "", onClick = () => {}, className = "", icon = null, disabled = false, iconPos = "right", type = "", loaderBtn, loading }) => {
    const isLoading = Boolean(loaderBtn ?? loading);
    const isDisabled = disabled || isLoading;

    const handleClick = (e) => {
        if (isDisabled) return;
        onClick(e);
    };

    const renderIcon = () => {
        if (!icon) return null;
        if (typeof icon === "string") return <i className={icon} />;
        return icon;
    };

    return (
        <button id={id} type="button" className={`button-ui ${className} ${type}`.trim()} onClick={handleClick} disabled={isDisabled} aria-busy={isLoading}>
            {isLoading ? (
                <div className="loader__btn">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            ) : (
                <>
                    {icon && iconPos === "left" && renderIcon()}
                    {label && <span className="button-ui__label">{label}</span>}
                    {icon && iconPos === "right" && renderIcon()}
                </>
            )}
        </button>
    );
};

export default ButtonUi;
